import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchUploads, clearUploads } from '@store/slices/uploadsSlice';

export const UploadsInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingUploads = useAppSelector((state) => state.uploads.isLoading);
  const hasFetched = useAppSelector((state) => state.uploads.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear uploads when user logs out
    if (!username) {
      dispatch(clearUploads());
      return;
    }

    // Fetch uploads when user is available and we haven't fetched yet
    if (!hasFetched && !isLoadingUploads) {
      dispatch(fetchUploads());
    }
  }, [user?.username, hasFetched, isLoadingUploads, dispatch]);

  return null;
};
